export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14011.fb165035.jpg";